import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

import type {
  SlaTaskFormValues,
  SlaTaskRow,
  SlaAffectedClientsData,
  SlaRaisedAlertRecipient,
  SlaTaskExecutionHistoryEntry,
} from '../../shared/types/sla-task-types';

export function getSLATasks(): Promise<SlaTaskRow[]> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks`);
}

export function getSLATask(taskId: string): Promise<SlaTaskRow> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}`);
}

export function createSLATask(data: SlaTaskFormValues): Promise<SlaTaskRow> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks`, {
    data,
    method: 'POST',
  });
}

export function updateSLATask(taskId: string, data: Partial<SlaTaskFormValues>): Promise<SlaTaskRow> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}`, {
    data,
    method: 'PATCH',
  });
}

export function deleteSLATask(taskId: string): Promise<void> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}`, {
    method: 'DELETE',
  });
}

export function getSLATaskAffectedClients(taskId: string): Promise<SlaAffectedClientsData> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}/affected-clients`);
}

export function getSLATaskExecutionHistory(taskId: string): Promise<SlaTaskExecutionHistoryEntry[]> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}/execution-history`);
}

export function getSLATaskRaisedAlerts(taskId: string, messageId: string): Promise<SlaRaisedAlertRecipient[]> {
  return request(`${ROOT_SERVER_URL}/api/feed-sla-tasks/${taskId}/raised-alerts/${encodeURIComponent(messageId)}`);
}
